import {TimeZone} from '@hconnect/common/types'
import {DateRangePicker} from '@hconnect/uikit/src/lib2'
import {SelectionItem} from '@hconnect/uikit/src/lib2/components/simpleDatePicker/types'
import {Theme, useMediaQuery} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {QuickSelectionId} from '../types'

type DateTimeRangePickerProps = {
  timeRangeParam: string
  onTimeRangeParamChange: (timeRange: string) => void
  disabled?: boolean
  timezone: TimeZone
  quickSelectionItems: SelectionItem<QuickSelectionId>[]
  inverted?: boolean
}

export const DateTimeRangePicker: React.FC<DateTimeRangePickerProps> = ({
  timeRangeParam,
  onTimeRangeParamChange,
  disabled,
  timezone,
  quickSelectionItems,
  inverted = false
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))

  return (
    <DateRangePicker
      onTimeRangeParamChange={onTimeRangeParamChange}
      timeRangeParam={timeRangeParam}
      singleDateSwitchLabel={t('quickSelection.pickSingleDate')}
      selectionItems={quickSelectionItems}
      timezone={timezone}
      fullWidth={isMobile}
      withForm={true}
      disabled={disabled}
      isContrastMode={inverted}
    />
  )
}
